import { getDataDependency } from 'gandi.react-helpers';
export const makeWrapHandler = (Wrapped, Hoisted, getWrapper) => handlerName => {
  const wrappedHandler = getDataDependency(Wrapped, handlerName);
  if (!wrappedHandler) {
    return;
  }
  Hoisted[handlerName] = getWrapper(wrappedHandler);
};